/**
 * @generated SignedSource<<f5a2a67e34a8232bc3664134f08daebc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueCreateFooter_nativeIssueTable_rankField$data = {
  readonly fieldId: string | null | undefined;
  readonly jqlTerm: string;
  readonly " $fragmentType": "issueCreateFooter_nativeIssueTable_rankField";
};
export type issueCreateFooter_nativeIssueTable_rankField$key = {
  readonly " $data"?: issueCreateFooter_nativeIssueTable_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueCreateFooter_nativeIssueTable_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueCreateFooter_nativeIssueTable_rankField",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "jqlTerm"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "4825e2c6c298f55e96e5d8d0ac576ae3";

export default node;
